import { Input, Tooltip, InputNumber, Icon } from 'antd';
import React, { Component } from 'react';
import InputFormat from '../../../../../components/input-format';
import OrderHelper from '../../../../../services/orderHelper'
import lang from '../../../../../languages/en'

class RowItem extends Component {
    state = {
        totalValue: '0',
        itemValue: 0,
        isQuantityError: false
    }

    onChange = (originalValue, valueFormat) => {
        // prevent user input dot char
        if (originalValue && originalValue.toString().includes('.') || valueFormat && valueFormat.toString().includes('.')) {
            return false
        }

        if (originalValue && originalValue.toString().length > 4 || valueFormat && valueFormat.toString().length > 4) {
            return false
        }

        const { props } = this
        const originalTotalValue = props.itemData.QuantityOrderedIN * props.itemData.adjustedValue
        const maxValue = props.itemData.QuantityOrderedIN
        const value = valueFormat || originalValue
        const { itemData } = props

        // calculate total values of current item
        let totalValue = value === '' ? '0' : itemData.adjustedValue * value
        if (isNaN(totalValue)) {
            totalValue = '0'
        }

        const leftTotalValue = totalValue === '' ? originalTotalValue : originalTotalValue - totalValue
        const validValue = Number(value)
        const isQuantityError = validValue > maxValue ? true : false

        this.setState({
            itemValue: validValue,
            totalValue,
            leftQuantity: maxValue - value,
            leftTotalValue,
            isQuantityError
        })

        // save new value everytime user input something new
        props.onChange({
            ID: itemData.ID,
            ItemCode: itemData.ItemCode,
            SKU: itemData.SKU,
            totalValue,
            quantity: validValue,
            isQuantityError
        })
    }

    render() {
        const { itemData } = this.props
        const { save_item } = this.props.itemData
        const { totalValue, itemValue, leftQuantity, leftTotalValue, isQuantityError } = this.state

        return (
            <tr id="row-item">
                <td style={{ width: '45px' }}>
                    <span className='no'>{this.props.no}</span>
                </td>
                <td style={{ width: '150px' }} id="item-sku-infor-order">
                    <Input
                        disabled
                        value={itemData.SKU}
                    />
                </td>
                <td style={{ width: '175px' }}>
                    <Input
                        disabled
                        value={itemData.ItemCode}
                    />
                </td>
                <td style={{ width: '190px' }}>
                    <Input
                        disabled
                        value={itemData.ItemName}
                    />
                </td>
                {/* <td style={{ width: '25px' }} className="text-center td-discount">
                    {!OrderHelper.item.priceIsDiscount(itemData) ? '' :
                        <Tooltip
                            title={OrderHelper.item.titleDiscount(itemData)}
                        >
                            <i className="fa fa-exclamation-circle icon-price-discount" aria-hidden="true"></i>
                        </Tooltip>
                    }
                </td> */}
                <td style={{ width: '150px' }} id='item-value-infor-order' className={"cols-item-value " + (save_item ? 'save-item-success' : '') + ' item-value'}>
                    <div className="box-price-adjusted">
                        {!OrderHelper.item.priceIsDiscount(itemData) ? '' :
                            <Tooltip
                                title={OrderHelper.item.titleDiscount(itemData)}
                            >
                                <Icon type="info-circle" className="icon-pa-price-discount" />
                            </Tooltip>
                        }
                        <InputNumber
                            className={(save_item ? 'save-item-success' : '') + ' text-right ' + (!OrderHelper.item.priceIsDiscount(itemData) ? ' ': ' price-adjusted-has-price-discount')}
                            disabled
                            precision={2}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            value={itemData.adjustedValue}
                        />
                    </div>
                </td>
                <td style={{ width: '80px' }} className='qty-item'>
                    <Input
                        className="text-right black-text"
                        disabled
                        value={
                            leftQuantity === undefined
                                || leftQuantity === ''
                                || isNaN(leftQuantity)
                                ? itemData.QuantityOrderedIN
                                : leftQuantity
                        }
                    />
                </td>
                <td style={{ width: '140px' }}>
                    <InputNumber
                        className="text-right black-text"
                        precision={2}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        disabled
                        value={
                            leftTotalValue === undefined
                                || leftTotalValue === ''
                                || isNaN(leftTotalValue)
                                ? itemData.QuantityOrderedIN * itemData.adjustedValue
                                : leftTotalValue
                        }
                    />
                </td>
                <td style={{ width: '80px', minWidth: '80px', backgroundColor: 'rgb(0, 176, 240)' }}>
                    <Tooltip
                        placement="bottomLeft"
                        visible={isQuantityError}
                        title={lang.split_order_quantity_exceed_original}
                        overlayClassName='tooltip-error'
                    >
                        <InputFormat
                            autoFocus={this.props.no === 1}
                            className={`text-right black-text ${isQuantityError ? 'quantity-error' : ''}`}
                            value={itemValue}
                            isRedstar={false}
                            onChange={this.onChange}
                        />
                    </Tooltip>
                </td>
                <td style={{ width: 'auto', backgroundColor: 'rgb(0, 176, 240)' }}>
                    <InputNumber
                        precision={2}
                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        className="text-right black-text gray-color"
                        disabled
                        value={totalValue}
                    />
                </td>
            </tr>
        )
    }
}

export default RowItem



// WEBPACK FOOTER //
// ./src/containers/orders/components/split-modal/item/index.js